// ANGULAR DEPENDANCY
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// EXTERNAL DEPENDANCY
import { Observable } from 'rxjs';

// SERVICES
import { ApiConfigService } from '../../../core/services/api-config/api-config.service';
import { BaseService } from '../../../core/services/base/base.service';
import { TokenStorageService } from '../../../core/services/token-storage/token-storage.service';

// COMMON INTERFACES
import { ApiPayload } from '../../../../models/common/api/api-payload.interface';
import { ApiResponse } from '../../../../models/common/api/api-response.interface';

// COMMON UTILS
import { APIUtil } from '../../../../core/utils/api-util';

// CONSTANTS
import { BUSINESS_API_URL } from '../../../../../app/constants/api/business';

/**
 * This service is for business api calls
 * For handle business api calls
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>) initially created business service
 */
@Injectable()
export class BusinessService extends BaseService {

  constructor(
    protected httpClient: HttpClient,
    protected tokenStorage: TokenStorageService,
    public apiConfig: ApiConfigService) {
    super(httpClient, tokenStorage);
  }

  /**
	   * Business common master api
	   * @param payload : Api common payload object
	   * @returns Observable<ApiResponse>
	   */
  public businessCommon(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['type'];
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${BUSINESS_API_URL[payload.data.type]}`, replaceParams, payload);

    return this.post(url, payload.data.data);
  }

  /**
	  * create the business
	  * @param payload : Api common payload object
	  * @returns Observable<ApiResponse>
	  */
  public createBusiness(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${BUSINESS_API_URL.CREATE_BUSINESS}`;

    return this.post(url, payload);
  }

  /**
	  * Update the Business Settings
	  * @param payload : Api common payload object
	  * @returns Observable<ApiResponse>
	  */
   public businessSetting(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${BUSINESS_API_URL.BUSINESS_SETTING}`;

    return this.put(url, payload);
    }
  /**
	  * Select the business
	  * @param payload : Api common payload object
	  * @returns Observable<ApiResponse>
	  */
  public selectBusiness(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${BUSINESS_API_URL.SELECT_BUSINESS}`;

    return this.post(url, payload);
  }

    /**
	  * Get Business By User Id
	  * @param payload : Api common payload object
	  * @returns Observable<ApiResponse>
	  */
  public getBusinessByUserId(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${BUSINESS_API_URL.BUSINESS_BY_USER_ID}`;

    return this.get(url);
  }


  /**
  * change the business by Id
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public changeBusiness(payload: ApiPayload): Observable<ApiResponse> {
	const replaceParams = ['businessId'];
	const url = APIUtil.getAppendParams(`${this.apiConfig.getApiUrl()}${BUSINESS_API_URL.CHANGE_BUSINESS}`, replaceParams, payload);

    return this.post(url, {});
  }

}

